import React from 'react';
import { Button, TextLink, Typography } from '@guildeducationinc/recess';
import { APPLICATIONS_URL } from '@src/constants';
import ApplicationCard from '@shared/ApplicationCard/ApplicationCard';
import ErrorMessage from '@shared/ErrorMessage/ErrorMessage';
import { clickable } from '@src/analytics';
import useApplications from '@src/hooks/useApplications';
import { ApplicationsActionCard } from './ApplicationsActionCard';
import { NextStepsToast } from './NextStepsToast';
import './Applications.scss';

const Applications: React.FC = () => {
  const {
    completedApplications,
    applicationsToFinish,
    approvedApplications,
    error,
  } = useApplications();

  if (error) {
    return <ErrorMessage />;
  }

  const toFinishCards = applicationsToFinish.map((application) => (
    <ApplicationCard key={application.id} status='started' {...application} />
  ));

  const completedCards = completedApplications.map((application) => (
    <ApplicationCard key={application.id} status='completed' {...application} />
  ));

  const approvedCards = approvedApplications.map((application) => (
    <ApplicationCard key={application.id} status='approved' {...application} />
  ));

  const applications = [...toFinishCards, ...completedCards, ...approvedCards];

  const applicationsText = applications.length === 1 ? 'application' : 'applications';

  return applications.length > 0 ? (
    <>
      <Typography variant='body1'>
        You have {applications.length} {applicationsText} total.
        <TextLink
          className='seeAllApplicationsLink'
          href={APPLICATIONS_URL}
          onClick={() =>
            clickable({
              product: 'home',
              loggedIn: true,
              tag: 'learn_skills',
              text: 'applications_see_all',
              type: 'link',
            })
          }
          variant='standalone'
        >
          See all
        </TextLink>
      </Typography>
      {approvedApplications.length ? (
        <NextStepsToast
          applications={approvedApplications}
          applicationsUrl={APPLICATIONS_URL}
          status='approved'
        />
      ) : (
        <NextStepsToast
          applications={completedApplications.filter((app) => app.state !== 'deferred')}
          applicationsUrl={APPLICATIONS_URL}
          status='completed'
        />
      )}
      {applications.slice(0, 3)}
      <Button
        href={APPLICATIONS_URL}
        onClick={() =>
          clickable({
            product: 'home',
            loggedIn: true,
            tag: 'learn_skills',
            text: 'applications_see_all_applications',
            type: 'button',
          })
        }
      >
        See all applications
      </Button>
    </>
  ) : (
    <ApplicationsActionCard />
  );
};

export default Applications;
